import './filters.scss';

/**
 * version    1.0
 * class      <type> (filters)
 * classdesc
 */
export class Filters {}
